import React, { useState } from 'react';
import { useGlobalStyles } from 'GlobalStyles';
import { usePageTitle } from 'hooks';
import DraftsProvider from 'providers/DraftsProvider';
import strings from 'strings';
import DraftsManager from 'UI/components/organisms/DraftsManager';
import { FormFieldsMap } from 'UI/components/organisms/JobOrderForm/fields';
import ContentPageLayout from 'UI/components/templates/ContentPageLayout';
import { PageTitles } from 'UI/constants/defaults';
import { EntityType } from 'UI/constants/entityTypes';

import { NewJobOrder as NewJobOrderContent } from '../NewJobOrder';

const draftValidationFields = [FormFieldsMap.Position.key];

/**
 * @typedef {Object} NewJobOrderProps
 * @property {*} history
 * @property {*} location
 */
export const NewJobOrder = props => {
  usePageTitle({ title: PageTitles.JobOrderCreate });
  const globalClasses = useGlobalStyles();

  const [selectedDraft, setSelectedDraft] = useState(null);

  const handleOnSelectDraft = draft => {
    setSelectedDraft(draft);
  };

  return (
    <ContentPageLayout
      text={strings.inventory.jobOrders.create.newJobOrder.title}
      titleLabelProps={{ backNavigation: true }}
    >
      <div className={globalClasses.itemCreationDataWrapper}>
        <DraftsProvider type={EntityType.Joborder} validationFields={draftValidationFields}>
          <DraftsManager type={EntityType.Joborder} onSelectDraft={handleOnSelectDraft} />
          <NewJobOrderContent key={selectedDraft?.id || 0} {...props} />
        </DraftsProvider>
      </div>
    </ContentPageLayout>
  );
};
